import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"background":"linear-gradient(180deg, #1d242c, #1f2937)"},
  class: "py-1 px-2 flex items-center justify-between bg-primary text-xs text-white"
}

import { useUsersStore } from "@/stores/v2";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterMain',
  setup(__props) {

const userStore = useUsersStore();

const loggedInUser = computed(() => userStore.getCurrentUser);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("p", null, [
      _cache[0] || (_cache[0] = _createTextVNode(" Logged in as ")),
      _createElementVNode("strong", null, _toDisplayString(loggedInUser.value?.name), 1)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("p", null, "Version: 0.0.1", -1))
  ]))
}
}

})